import React from 'react';
import PropTypes from 'prop-types';

export default class RadioGroup extends React.Component {

    static propTypes = {
        value: PropTypes.any,
        items: PropTypes.array.isRequired,

        disabled: PropTypes.bool,

        onChange: PropTypes.func.isRequired,

        stateFull: PropTypes.bool       // if true - will use state (!)
    }

    static defaultProps = {
        disabled    : false,
        stateFull   : false
    }

    constructor(props) {
        super(props);

        if (this.props.stateFull) {
            this.state = {
                value: props.value
            }
        }
    }

    onOptionClick = (value) => {
        if (this.props.disabled) return;

        if (this.props.stateFull) {
            this.setState({
                value: value
            },()=>{
                this.props.onChange(value)
            })
        } else {
            this.props.onChange(value)
        }


    }

    render() {
        const classes = Classes('ui5-radio-group', this.props.className, {
            'is-disabled': this.props.disabled,
        });

        const selectedValue = this.props.stateFull ? this.state.value : this.props.value

        return (
            <div className={classes}>
                {_.map(this.props.items, item=>
                    <div key={item.value} className="radio-option" onClick={item.disabled ? null : () => this.onOptionClick(item.value)}>
                        <div className="radio-label">
                            <div className={Classes("ui5-radio", "s-13", "m-r-10", {selected: item.value === selectedValue})}/>
                            <div className="ui5-txt-default">{item.label}</div>
                            {item.iconRight && <div className={Classes("label-icon-right", item.iconRight)}/>}
                        </div>
                        {item.description && <div className="radio-description ui5-txt-not-important-small m-t-5">{item.description}</div>}
                    </div>
                )}
            </div>
        )
    }
}